import * as yup from 'yup';

export const enrollDealerUserProfileSchema = yup.object().shape({
  securityProfile: yup.string().required('* Mandatory field'),
});
